import React, { Suspense } from 'react'

import SuspenseRootFallback from './SuspenseRootFallback'

interface Props {
  children?: React.ReactNode
}

const SuspenseRoot: React.FC<Props> = props => {
  return <Suspense fallback={<SuspenseRootFallback />}>{props.children}</Suspense>
}

export default SuspenseRoot
